import $ from 'jquery';
import angular from 'angular';

const MODULE_NAME = 'scrollToElement';

let scrollToElement = () => {
	'nginject';
	return (selector, speed, positionToTop) => {
		if (selector) {
			let element = $(selector);

			if (element.length) {
				let elementOffset = element.offset().top;
				/* let elementHeight = element.height();
				let windowHeight = $(window).height();
				let offset;

				if (elementHeight < elementOffset && !positionToTop) {
					offset = elementOffset - (windowHeight / 2 - elementHeight / 2);
				} else {
					offset = elementOffset;
				} */

				$('html, body').animate({
					scrollTop: positionToTop ? elementOffset - positionToTop : elementOffset
				}, isNaN(speed) ? 500 : speed);
			}
		}
	};
};

export default angular.module(MODULE_NAME, []).service('scrollToElement', scrollToElement).name;


